import { environment } from '../../environments/environment';

export const base64toBlob = (b64Data): Blob => {
  const block = b64Data.split(';');
  const contentType = block[0].split(':')[1];
  const realData = block[1].split(',')[1];
  const sliceSize = 1024;
  const byteCharacters = atob(realData);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, {type: contentType});
};

export function getEstablishmentImage(establishment, imageType) {
    if (establishment.image_key) {
      return mountCdnPath(establishment.image_key[imageType]);
    } else if (establishment.image && establishment.image[imageType]) {
      const imageSrc = establishment.image[imageType];
      return imageSrc;
    }

    return undefined;
}

export function mountCdnPath(imageKey) {
    const imageSrc = `${environment.CDN_IMAGES_WEB}/${imageKey}`;
    return imageSrc;
}

